module.exports = "<h2>Thank you</h2>\r\n<p>Your information has been submitted.</p>"